export class Product {
	public id: number
	public name: string

	constructor(data: { id: number; name: string }) {
		this.id = data.id
		this.name = data.name
	}

	static create(data: Partial<Product>): Product {
		const defaultData: Product = {
			id: 0,
			name: '',
		}

		return new Product({
			...defaultData,
			...data,
		})
	}
}

// Product IDs. While its not the best way to handle it, the products are fixed and won't change
export const PRODUCT_PLAYER_ID = 1
export const PRODUCT_BOX_ONE_SHOT_ID = 8
export const PRODUCT_BOX_ADDON_ID = 9
export const PRODUCT_SOUNDREEF_ADDON_ID = 11
